import { useMemo } from "react";
import { useUnclaimedTransactions } from "../../CustomHooks/Queries";
import { getUnclaimedCashBackAmount } from "../../Utils/helpers";

/**
 * Paper 76Q-0 — Add Funds hub (member setup flow).
 */
export default function MemberSetupAddFundsHub({
  cashbackBonus = 100,
  showDirectDepositSection = false,
  onOneTimeDeposit,
  onRecurringDeposit,
  onDirectDeposit,
  onFundLater,
}) {
  const { data: unclaimedTransactionsData } = useUnclaimedTransactions();
  const cashBackAmount = useMemo(
    () => getUnclaimedCashBackAmount(unclaimedTransactionsData),
    [unclaimedTransactionsData]
  );

  const directDepositBenefits = [
    "Set it once, funds arrive automatically",
    "Earn up to $120/year in cash back on rent",
    "No fees, cancel anytime",
  ];

  return (
    <div className="bc-add-funds-hub">
      <div className="bc-add-funds-hub-intro">
        <h2 className="bc-add-funds-hub-title">Add Funds</h2>
        <p className="bc-add-funds-hub-subtitle">
          {`Fund your Stake account to start shopping and earn your ${cashBackAmount} Cash Back bonus.`}
        </p>
      </div>

      <button type="button" className="bc-add-funds-hub-option" onClick={onOneTimeDeposit}>
        <div className="bc-add-funds-hub-option-text">
          <span className="bc-add-funds-hub-option-title">One time deposit</span>
          <span className="bc-add-funds-hub-option-desc">From checking or debit account</span>
        </div>
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden>
          <path
            d="M1 1L7 7L1 13"
            stroke="#6C7086"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <button type="button" className="bc-add-funds-hub-option" onClick={onRecurringDeposit}>
        <div className="bc-add-funds-hub-option-text">
          <span className="bc-add-funds-hub-option-title">Recurring deposit</span>
          <span className="bc-add-funds-hub-option-desc">From checking or debit account</span>
        </div>
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden>
          <path
            d="M1 1L7 7L1 13"
            stroke="#6C7086"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {showDirectDepositSection && (
        <>
          <div className="bc-add-funds-hub-divider-row">
            <span className="bc-add-funds-hub-divider-line" />
            <span className="bc-add-funds-hub-divider-label">{`Want to earn ${cashBackAmount} instantly?`}</span>
            <span className="bc-add-funds-hub-divider-line" />
          </div>

          <div className="bc-add-funds-hub-dd-wrap">
            <span className="bc-add-funds-hub-dd-badge">{`GET ${cashBackAmount} INSTANTLY`}</span>
            <div className="bc-add-funds-hub-dd-card">
              <div className="bc-add-funds-hub-dd-header">
                <span className="bc-add-funds-hub-dd-icon" aria-hidden>
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path
                      d="M11 2L13.09 8.26L20 8.27L14.45 12.14L16.54 18.41L11 14.54L5.46 18.41L7.55 12.14L2 8.27L8.91 8.26L11 2Z"
                      fill="#54FF99"
                    />
                  </svg>
                </span>
                <div className="bc-add-funds-hub-dd-copy">
                  <span className="bc-add-funds-hub-dd-title">Direct Deposit</span>
                  <span className="bc-add-funds-hub-dd-desc">
                    Route your paycheck to Stake and get paid up to 2 days early
                  </span>
                </div>
              </div>
              <ul className="bc-add-funds-hub-dd-benefits">
                {directDepositBenefits.map((text) => (
                  <li key={text}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
                      <circle cx="10" cy="10" r="10" fill="#54FF99" />
                      <path
                        d="M6 10L9 13L14 7"
                        stroke="#171B26"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {text}
                  </li>
                ))}
              </ul>
              <button type="button" className="bc-add-funds-hub-dd-cta" onClick={onDirectDeposit}>
                Set up direct deposit
              </button>
            </div>
          </div>
        </>
      )}

      <button type="button" className="bc-add-funds-hub-later" onClick={onFundLater}>
        Fund your account later
      </button>
    </div>
  );
}
